import { Component, Input, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CLIPBOARD } from '@shared/dom';
import { TotpPayload } from '@shared/services/totp/totp.service';
import { TimeUtil } from '@shared/utils/time.util';

@Component({
  selector: 'app-totp-code',
  templateUrl: './totp-code.component.html',
  styleUrl: './totp-code.component.scss',
  standalone: false,
})
export class TotpCodeComponent {
  private readonly clipboard = inject<Clipboard>(CLIPBOARD);
  private readonly domSanitizer = inject(DomSanitizer);

  public viewQr = true;
  public copied = false;

  @Input({ required: true }) totp: TotpPayload;

  public get otpParts(): string[] {
    return this.totp.secret.match(/[0-9A-Z]{4}/g);
  }

  public get safeAuthUrl() {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(this.totp.authUrl);
  }

  public async copySecret(): Promise<void> {
    await this.clipboard.writeText(this.totp.secret);

    this.copied = true;
    setTimeout(() => (this.copied = false), TimeUtil.toMilliseconds({ seconds: 2 }));
  }
}
